const SUCCESS_STATUSES = ['completed', 'partial_success', 'partially_completed']
const FAILED_STATUSES = ['failed']

const STATUS_LABELS = {
  completed: 'Completed',
  partial_success: 'Completed',
  partially_completed: 'Completed',
  failed: 'Failed',
  processing: 'Processing',
  pending: 'Pending',
  queued: 'Queued',
  starting: 'Starting',
  executing_parallel_streams: 'Analyzing Website',
  executing_step1: 'AI Analysis',
  executing_step2: 'Data Collection',
  executing_step2_format: 'Report Generation',
  executing_step3: 'Creating Recommendations',
  executing_convergence: 'Final Report',
  generating_actions: 'Generating Actions',
  executing_actions_parsing: 'Generating Actions'
}

export function isJobSuccessful(status) {
  return SUCCESS_STATUSES.includes(status)
}

export function isJobFailed(status) {
  return FAILED_STATUSES.includes(status)
}

export function isJobFinished(status) {
  return isJobSuccessful(status) || isJobFailed(status)
}

export function isJobProcessing(status) {
  return Boolean(status) && !isJobFinished(status)
}

export function getJobStatusLabel(status) {
  if (!status) return 'Unknown'

  if (STATUS_LABELS[status]) {
    return STATUS_LABELS[status]
  }

  if (status.includes('executing') && status.includes('stream')) {
    if (status.includes('step1') || status.includes('stream1')) return 'AI Analysis'
    if (status.includes('step2') || status.includes('stream2')) return 'Data Collection'
    if (status.includes('step3') || status.includes('stream3')) return 'Creating Recommendations'
    return 'Processing Analysis'
  }

  if (status.includes('executing')) {
    if (status.includes('step1')) return 'AI Analysis'
    if (status.includes('step2')) return 'Data Collection'
    if (status.includes('step3')) return 'Creating Recommendations'
    if (status.includes('convergence')) return 'Final Report'
    return 'Processing Analysis'
  }

  return status.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase())
}

export function normalizeJobRecord(row) {
  if (!row) return null

  const id = row.job_id || row.jobId || row.id
  return {
    ...row,
    id,
    userId: row.userId || row.user_id,
    folderPath: row.folderPath || row.folder_path,
    error: row.error || row.error_message,
    steps: row.steps || {},
    metadata: row.metadata || {}
  }
}

export function jobUpdateEffects(existingJob, updatedJob) {
  const previousStatus = existingJob?.status
  const nextStatus = updatedJob?.status
  const previousActionStatus = existingJob?.action_generation_status
  const nextActionStatus = updatedJob?.action_generation_status
  const actionCount = updatedJob?.action_count || 0

  const showActionsReady =
    previousActionStatus !== 'completed' &&
    nextActionStatus === 'completed' &&
    actionCount > 0

  const justFinished = !isJobFinished(previousStatus) && isJobFinished(nextStatus)

  return {
    showActionsReady,
    reloadJobs: showActionsReady || justFinished
  }
}
